module.exports = "/_next/static/images/27b94641d32a06af49ff6064bd136605-image-lg.jpg";